module.exports = __webpack_public_path__ + "img/IFX_LOGO_White.f3268a18.png";